import React, { createContext, useContext, useState, useCallback } from "react";
import DocumentViewerModal from "../../components/ui/modals/DocumentViewerModal";

const DocumentViewerContext = createContext(null);

export function DocumentViewerProvider({ children }) {
  const [viewerState, setViewerState] = useState({
    open: false,
    title: "",
    url: "",
    download: false,
    onReupload: undefined,
    reuploadButtonText: undefined,
  });

  const openDocument = useCallback(
    ({ title, url, download = false, onReupload, reuploadButtonText }) => {
      setViewerState({
        open: true,
        title,
        url,
        download,
        onReupload: typeof onReupload === "function" ? onReupload : undefined,
        reuploadButtonText,
      });
    },
    []
  );

  const closeDocument = useCallback(() => {
    setViewerState({
      open: false,
      title: "",
      url: "",
      download: false,
      onReupload: undefined,
      reuploadButtonText: undefined,
    });
  }, []);

  return (
    <DocumentViewerContext.Provider value={{ openDocument }}>
      {children}
      <DocumentViewerModal
        {...viewerState}
        onReupload={viewerState.onReupload}
        onClose={closeDocument}
      />
    </DocumentViewerContext.Provider>
  );
}

export function useDocumentViewerContext() {
  const ctx = useContext(DocumentViewerContext);
  if (!ctx) {
    throw new Error("useDocumentViewer must be used inside DocumentViewerProvider");
  }
  return ctx;
}
